import { css } from 'aphrodite';
import React from 'react';
import { Button } from '../../../../../components/Button';
import { styleSheet } from '../../styles';

interface PreviewFormActionsProps {
	isAttending: boolean | null;
	isPaidEvent: boolean;
	onSubmit: () => void;
}

export const PreviewFormActions: React.FC<PreviewFormActionsProps> = ({ isAttending, isPaidEvent, onSubmit }) => {
	return (
		<footer className={css(styleSheet.actions)}>
			<div className={css(styleSheet.divider)} />
			<div className={css(styleSheet.buttonContainer)}>
				<Button
					type='button'
					kind={isAttending && isPaidEvent ? 'reverse' : 'primary'}
					onClick={onSubmit}
					label={isAttending && isPaidEvent ? 'Proceed to Payment' : 'RSVP'}
					data-testid='button'
				/>
			</div>
		</footer>
	);
};
